import { useMutation } from "@tanstack/react-query";
import { errorModal } from "modules/error/ErrorHandlingModals";
import { ErrorResponse } from "types";

import { postUserAuthentificationService } from "../api";

export const useAuthenticateUserMutation = () => {
  return useMutation({
    mutationFn: postUserAuthentificationService,
    onSuccess: async () => {},
    onError: (error: ErrorResponse) => errorModal(error)
  });
};
